module.exports = __webpack_public_path__ + "img/3.62a9e432.png";